import { Button, Input, message, Space, Typography } from 'antd';
import { useState } from 'react';
import { apiDownload } from '../../../utils/Api';
import Overlay from '../../Overlay';
import ListReportCard from '../ListReportCard';

export default function ListMSEmail (props){
    
    const {
        sel = [],
        catalogues = {}
    } = props


    const list_id = catalogues.map(item => item.list_id);
    const vendor = catalogues.map(item => item.vendor);
    const actual_id = catalogues.map(item => item.actual_id);
    const name = catalogues.map(item => item.name);
    const isbns_count = catalogues.map(item => item.isbns_count);

    const [copied, setCopied] = useState(false);
    const [changedTextAreaText, setChangedTextAreaText] = useState("")
    
    const initialTextAreaValue = () => {
        let initial_text = sel.map((item,index) => {
            if(index < 1){
                return `"${name[index]} - ${isbns_count[index]} titles" | list id# ${actual_id[index]}` + "\nhttps://share.bookmanager.com/b2b/browse/filter/x/" + item.list_id + "/v/sequence";
            }else {
                return `\n\n"${name[index]} - ${isbns_count[index]} titles" | list id# ${actual_id[index]}` + "\nhttps://share.bookmanager.com/b2b/browse/filter/x/" + item.list_id + "/v/sequence";
            }
            
        })
        setChangedTextAreaText(initial_text.toString())
        return initial_text.join("")
    }

    const copyToClipboard = (e) =>{
        if(!navigator.clipboard){
            message.error("Can't copy");
            return; 
        }
        navigator.clipboard.writeText(changedTextAreaText);
        setCopied(true);
        setTimeout(() => {
            setCopied(false)
        },1000);
    }

    return (
        <div style={{"marginBottom": "10px"}}>
            <Typography.Paragraph>
                Using the button below, you can copy the links in the box and paste them into an email to share.
            </Typography.Paragraph>
            <Input.TextArea
                style={{"maxHeight" : "180px"}}
                rows={sel.length + 2}
                defaultValue={initialTextAreaValue}>
            </Input.TextArea>
            <div className="shim" /> <div className="shim" />
            <div style={{ "float": "right", "marginTop": "10px" }}>
                <Space>
                    <Overlay
                        width={1000}
                        component={
                            <ListReportCard
                                vendor={vendor}
                                actual_id={actual_id}
                                list_id={list_id}
                                list_name={name} />
                        }><Button>Report Card</Button>
                    </Overlay>                    
                    <Button onClick={(e) => copyToClipboard(e)} type={(copied ? "default" : "primary")}>{(copied) ? "Copied" : "Copy Your Links"}</Button>
                </Space>
            </div> 
        </div>
    );
}